import React from 'react';
import css from './TestimonialsSection.module.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      quote: '"Kicking off my MMA journey, I had no idea which gym would be the right fit for me. I used Grounddz to find a BJJ gym because I really wanted a place with a strong community feel. The platform made it super easy to navigate and compare all the local fight clubs in one place, which save me loads of time. I ended up finding a great BJJ gym in Mill Hill that focuses on solid fundamentals and has a really welcoming vibe. Exactly what I was looking for. Grounddz made the whole process way smoother than expected."',
      author: 'Immad. E',
      role: 'Martial Arts Enthusiast',
    },
    {
      id: 2,
      quote: '"GroundDZ made it so easy to find affordable gear for my son\'s karate classes — I saved money and gave a second life to quality kit. I even found a brilliant local gym we wouldn\'t have discovered otherwise. Love what this platform stands for."',
      author: 'Sarah M',
      role: 'Parent & Martial Arts Beginner',
    },
    {
      id: 3,
      quote: '"I used Grounddz to sell a rashguard and it was so simple to do and sold so quickly! The team is very efficient and approved my item very quickly. I\'d definitely use this platform again to resell and purchase!"',
      author: 'Sula.M',
      role: 'Bjj Pro Athlete',
    }
  ];

  return (
    <div className={css.section}>
      <div className={css.header}>
        <p className={css.title}>
          What the Grounddz Community Is Saying
        </p>

        <p className={css.description}>
          Real stories from people buying gear, finding gyms, and reconnecting
          with martial arts — one step at a time.
        </p>
      </div>

      <div className={css.testimonialsContainer}>
        {testimonials.map(testimonial => (
          <div key={testimonial.id} className={css.testimonialCard}>
            <div className={css.cardContent}>
              <p className={css.quote}>
                {testimonial.quote}
              </p>

              <p className={css.author}>
                {testimonial.author}<br />
                {testimonial.role}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialsSection;

